module.exports = __webpack_public_path__ + "9779d9a1/img/arrow-share-icon.00a12c29.svg";